import { unwrap } from '@/lib/apiEnvelope'
import { httpClient } from '@/lib/httpClient'
import type { ApiResponse } from '@/types/api'

import type { PushInscricaoRequest } from '../types/pushPayload'

export const pushApi = {
  /** Chave VAPID pública (base64url). */
  chavePublica: async (): Promise<string> => {
    const response = await httpClient.get<ApiResponse<string>>('/notificacoes/push/chave-publica')
    return unwrap(response)
  },

  /** Upsert pelo endpoint — pode ser chamado de novo sem efeito colateral. */
  inscrever: async (body: PushInscricaoRequest): Promise<void> => {
    await httpClient.post('/notificacoes/push/inscricao', body)
  },

  /** Idempotente. */
  cancelarInscricao: async (endpoint: string): Promise<void> => {
    await httpClient.delete('/notificacoes/push/inscricao', { data: { endpoint } })
  },
}
